import {cssTheme} from '@yandex-delivery/blocks'
import {css} from '@yandex-delivery/blocks/theme/css'
import {spacing} from '@yandex-delivery/blocks/theme/theme'

export const footerClasses = {
  root: css`
    overflow: hidden;
    z-index: 35;
    border-radius: ${spacing(2.5, 2.5, 0, 0)};
    color: ${cssTheme.default.day.everWhite};
    background: ${cssTheme.colors.deliveryGrey[500]};
    display: flex;
    justify-content: center;
    padding: ${spacing(6, 3.75, 3.75, 3.75)}; // 48px 30px 30px 30px
    box-sizing: border-box;
  `,
  footerContainer: css`
    inline-size: 100%;
    display: grid;
    gap: ${spacing(5)};
  `,
  firstLine: css`
    & > *:not(:last-child) {
      margin-block-end: ${spacing(1)};
    }
  `,
  separator: css`
    opacity: 0.1;
    border-block-end: ${spacing(0.25)} solid #a6a6a6;
  `,
  logoContainer: css`
    word-break: break-word;
    max-inline-size: fit-content;
  `,
  appContainer: css`
    flex-basis: 0;
    block-size: auto;
    max-inline-size: fit-content;
  `,
  navigation: css`
    margin-block-end: ${spacing(10)};
  `,
  legal: css`
    // TODO: Добавить цвет в cssTheme
    color: #f2f2f2;
    opacity: 0.6;

    margin-block-end: ${spacing(3.75)};

    & > *:first-child {
      margin-block-end: ${spacing(2)};
    }
  `,
  legalLinks: css`
    margin-block-end: ${spacing(5.5)};

    & > *:not(:last-child) {
      margin-block-end: ${spacing(1.25)};
    }
  `,
  caption1: css`
    // Размер в макете не соответствует размерам в Typography
    font-size: ${spacing(1.75)};
    line-height: ${spacing(2.5)};
  `,
}
